<div class="p-4 md:p-10 h-[calc(100vh-7.5rem)] bg-white overflow-auto flex-1 overscroll-contain pt-4">
  <div class="max-w-6xl mx-auto flex flex-col h-full">


    <div class="flex flex-col md:flex-row justify-between items-center gap-6 mb-8 md:mb-12">
      <!-- Header con fondo que contiene el texto y la flecha -->
      <div
        class="bg-[#f8f7f4] rounded-xl md:rounded-2xl p-6 md:p-10 w-full md:flex-1 flex flex-row items-center gap-4 md:gap-6 relative">
        <button (click)="goBack()"
          class="self-start mt-1 p-2 md:p-3 hover:bg-white rounded-full transition-all text-[#1a2e35]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 md:w-7 md:h-7" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12l14 0" />
            <path d="M5 12l4 4" />
            <path d="M5 12l4 -4" />
          </svg>
        </button>
        <div class="flex-1">
          <p class="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-1">{{ '::AssemblingOrderFor' |
            abpLocalization }}</p>
          <h2 class="text-xl md:text-4xl font-bold text-[#1a2e35] leading-tight">{{ clientName || ('::Loading' |
            abpLocalization) }}</h2>
        </div>

        <!-- Botón Agregar (Desktop - Dentro del fondo) -->
        <div class="hidden md:block md:min-w-[180px]">
          <app-metro-button variant="primary" [fullWidth]="true" [text]="'::Add' | abpLocalization" [icon]="iconCart"
            iconSize="20" iconColor="white" (clicked)="goToCatalog()">
          </app-metro-button>
        </div>
      </div>

      <!-- Botón Agregar (Mobile - Fuera del fondo) -->
      <div class="w-full md:hidden">
        <app-metro-button variant="primary" [fullWidth]="true" [text]="'::Add' | abpLocalization" [icon]="iconCart"
          iconSize="20" iconColor="white" (clicked)="goToCatalog()">
        </app-metro-button>
      </div>
    </div>

    <!-- Contenido del Carrito -->
    <div class="flex-1 space-y-4 mb-16">
      @if (isLoading) {
      <div class="flex flex-col items-center justify-center py-20">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-metro-blue"></div>
      </div>
      } @else {
      @for (item of cartItems; track item.wineId) {
      <app-metro-list-card-item [productName]="item.wineName" [imageUrl]="item.imageUrl" [items]="item.quantity"
        [price]="item.unitPrice" [isLoading]="isUpdating[item.wineId] || false" [showDeleteButton]="true"
        [maxAvailable]="999" (itemsChange)="updateQuantity(item.wineId, $event)" (deleteItem)="removeItem(item.wineId)">
      </app-metro-list-card-item>
      }

      @if (cartItems.length === 0) {
      <div class="bg-gray-50 p-16 rounded-2xl text-center border border-dashed border-gray-200">
        <div class="text-6xl mb-6">🛒</div>
        <h3 class="text-xl font-bold text-[#1a2e35] mb-2">{{ '::EmptyCart' | abpLocalization }}</h3>
        <p class="text-gray-400">{{ '::StartAddingWines' | abpLocalization }}</p>
      </div>
      }
      }
    </div>

    <!-- Resumen del Carrito -->
    @if (cartItems.length > 0) {
    <div class="mt-8 pt-10 border-t border-gray-100 pb-20">
      <div class="w-full space-y-4">

        <div class="flex justify-between items-center">
          <span class="text-gray-400 font-medium text-base">{{ '::SubTotal' | abpLocalization }}</span>
          <span class="font-bold text-lg text-gray-900">{{ formatCurrency(subtotal) }}</span>
        </div>

        <div class="flex justify-between items-center">
          <span class="text-gray-400 font-medium text-base">{{ '::Tax' | abpLocalization }} (21%)</span>
          <span class="font-bold text-lg text-gray-900">{{ formatCurrency(tax) }}</span>
        </div>

        <div class="flex justify-between items-center pt-6 border-t border-gray-50 mt-4">
          <span class="text-2xl font-bold text-[#1a2e35]">{{ '::Total' | abpLocalization }}</span>
          <span class="text-2xl font-bold text-[#1a2e35]">{{ formatCurrency(total) }}</span>
        </div>

        <div class="pt-12 flex justify-center">
          <div class="w-full max-w-md">
            <app-metro-button variant="primary" [fullWidth]="true" [text]="'::FinishManagement' | abpLocalization"
              (clicked)="goBack()">
            </app-metro-button>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Modal Catálogo -->
    @if (showCatalogModal) {
    <app-assisted-catalog [userId]="userId" [sommelierSlug]="sommelierSlug" [clientName]="clientName" (closed)="closeCatalogModal()">
    </app-assisted-catalog>
    }
  </div>
</div>